"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _TableFooterActions = _interopRequireDefault(require("./TableFooterActions.style"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*eslint-disable*/

var TableFooterActions = function TableFooterActions(_ref) {
  var onClear = _ref.onClear,
    clearLabel = _ref.clearLabel,
    selectedItems = _ref.selectedItems,
    footerActions = _ref.footerActions;
  return /*#__PURE__*/_react["default"].createElement(_TableFooterActions["default"], {
    isDisabled: !selectedItems
  }, onClear && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("a", {
    onClick: selectedItems ? onClear : function () {}
  }, clearLabel)), !R.isEmpty(footerActions) && footerActions.map(function (node) {
    return /*#__PURE__*/_react["default"].createElement("span", null, node);
  }));
};
TableFooterActions.defaultProps = {
  onClear: null,
  clearLabel: '',
  selectedItems: null,
  footerActions: []
};
TableFooterActions.propTypes = {
  onClear: _propTypes["default"].func,
  clearLabel: _propTypes["default"].string,
  selectedItems: _propTypes["default"].number,
  footerActions: _propTypes["default"].arrayOf(_propTypes["default"].node)
};
var _default = exports["default"] = TableFooterActions;